<div >
  <p-fileUpload
    name="xlsxFile"
    mode="basic"
    [auto]="false"
    [customUpload]="true"
    accept=".xlsx"
    chooseLabel="Bulk Student Import"
    chooseIcon="pi pi-upload"
    maxFileSize="5000000"
    (onSelect)="onFileSelect($event)"
    class="w-full"
    styleClass="upload_w"
  ></p-fileUpload>

  <p-dialog
    header="Student Data Upload"
    [visible]="dialogVisible()"
    (visibleChange)="dialogVisible.set($event)"
    [modal]="true"
    [closable]="!isUploading()"
    [style]="{ width: '40rem' }"
    (onHide)="closeDialog()"
  >
    <div class="flex flex-column gap-3">
      <div class="flex flex-row gap-3 align-items-center">
        <b>File:</b> <span>{{ fileName() }}</span>
      </div>
      <div class="flex flex-row gap-3 align-items-center">
        <b>Total Records:</b> <span>{{ totalRecords() }}</span>
      </div>
      <div class="flex flex-row gap-3 align-items-center">
        <b>Processed:</b> <span>{{ processedRecords() }}</span>
      </div>
      <div class="flex flex-row gap-3 align-items-center">
        <b>Failed:</b> <span>{{ failedRecords().length }}</span>
      </div>
      <p-progressBar
        [value]="progress()"
        [showValue]="true"
        styleClass="w-full"
        color="red"
        [unit]="'%'"
      ></p-progressBar>
      <div *ngIf="isUploading()" class="text-center text-primary font-medium">Uploading...</div>
      <div *ngIf="!isUploading()">
        <div class="flex flex-row gap-3 align-items-center">
          <b>Upload Summary:</b>
          <span class="text-green-600">Success: {{ uploadSummary().success }}</span>
          <span class="text-red-600">Failed: {{ uploadSummary().failed }}</span>
        </div>
        <div *ngIf="failedRecords().length > 0" class="flex justify-content-end mt-4 gap-2">
          <button
            pButton
            type="button"
            label="Download Failed Results"
            class="p-button-warning"
            (click)="downloadFailedResults()"
          ></button>
          <button pButton type="button" label="Close" (click)="closeDialog()" styleClass="cls"></button>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
